"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTINUE_WITHOUT_FORECAST_COPY = exports.CHOOSE_PLAN_ACTION_COPY = exports.FORECAST_NEEDS_PLAN_BODY_COPY = exports.FORECAST_NEEDS_PLAN_TITLE_COPY = void 0;
/**
 * T1-W01 (web #1914) / the shared "needs-plan" outcome (setupCompletion.ts): what
 * setup's forecast step says when the paywall refused the forecast (402). Moved
 * from web's paywallCopy.ts so both apps say the same thing (rule 17, agreed
 * 2026-10-12). There is no "Try again": a retry gets the same 402 until there's a plan.
 */
exports.FORECAST_NEEDS_PLAN_TITLE_COPY = "Choose a plan to build your forecast";
exports.FORECAST_NEEDS_PLAN_BODY_COPY = "Building your forecast needs an active plan. Choose one to build it, or carry on without it for now.";
/** The button to the plan page. */
exports.CHOOSE_PLAN_ACTION_COPY = "Choose a plan";
/** Finishes setup with no forecast; also the "failed" notice's way on. */
exports.CONTINUE_WITHOUT_FORECAST_COPY = "Continue without a forecast";
//# sourceMappingURL=forecastPaywallCopy.js.map